import GeoJSON from 'ol/format/GeoJSON';

const format = new GeoJSON();

function formatCoord(value, negative, positive) {
  const rounded = Math.round(value * 100) / 100;
  const formatted = `${Math.abs(rounded)}°`;
  if (negative && positive) {
    return `${formatted} ${value < 0 ? negative : positive}`;
  }
  return formatted;
}

function formatRange(range, directions) {
  const [min, max] = range;
  if (max < 0 === min < 0) {
    // both coords are in the same hemisphere
    return [formatCoord(min), formatCoord(max, ...directions)];
  }

  return range.map(coord => formatCoord(coord, ...directions));
}

export default geometry => {
  const latDirections = ['S', 'N'];
  const lonDirections = ['W', 'E'];

  if (geometry.type === 'Point') {
    const [lon, lat] = geometry.coordinates;
    return [
      formatCoord(lat, ...latDirections),
      formatCoord(lon, ...lonDirections),
    ];
  }

  const olGeometry = format.readGeometry(geometry);
  const [maxLon, maxLat, minLon, minLat] = olGeometry.getExtent();
  return [
    formatRange([minLat, maxLat], latDirections),
    formatRange([minLon, maxLon], lonDirections),
  ].map(range => range.join(' - '));
};
